import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

import errorBoundary from '@ifeng/errorBoundary';

import Slides from '@ifeng/ui_pc_slides';

import { rel } from '../../../../../utils/rel';
import { formatImage } from '../../../../../utils/formatImg';
class Slider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        // console.log(this.props);
        const { content } = this.props;

        const sliderTmpl = function sliderTmpl(item) {
            return (
                <div>
                    <a
                        className={styles.blockA}
                        href={item.url}
                        target="_blank"
                        alt={item.title}
                        title={item.title}
                        rel={rel}>
                        <img src={formatImage(item.thumbnail, 1000, 480)} style={{ width: '100%', height: 480 }} />
                    </a>
                </div>
            );
        };

        const sliderConfig = {
            arrows: 'hover',
            dots: true,
            dotsAction: 'click',
            direction: 'forward',
            pauseOnHover: true,
            autoplayInterval: 5000,
            axis: 'horizonta',
            initialSlide: 0,
            unitSize: 1000,
            speed: 500,
            infinite: true,
            extension: 2,
            padding: 1,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
            sliderTmpl,
        };

        return (
            <div className={styles.sliderContainer}>
                <div className={styles.sliderWraper}>
                    <Slides content={content} config={sliderConfig} />
                    <div className={styles.mask_r} />
                    <div className={styles.mask_l} />
                </div>
            </div>
        );
    }
}
export default errorBoundary(Slider);
